import React from "react";

import { Check, X } from "lucide-react";
import { useTranslation } from "react-i18next";

import { cn } from "@/src/lib/utils";
import {
  isPasswordRuleValid,
  PASSWORD_RULE_LIST,
} from "@/src/utils/data/passwordRules";

import type { JSX } from "react";

interface PasswordRulesChecklistProps {
  password: string;
}

function PasswordRulesChecklist({
  password,
}: PasswordRulesChecklistProps): JSX.Element {
  const { t } = useTranslation("login");

  return (
    <ul className="flex flex-wrap gap-x-4 gap-y-2">
      {PASSWORD_RULE_LIST.map((rule) => {
        const isRuleValid = isPasswordRuleValid(password, rule);

        return (
          <li key={rule} className="flex items-center gap-1.5">
            {isRuleValid ? (
              <Check
                className="text-status-active size-3.5 shrink-0"
                data-testid="password-rule-met"
              />
            ) : (
              <X
                className="text-muted-foreground size-3.5 shrink-0"
                data-testid="password-rule-unmet"
              />
            )}
            <span
              className={cn(
                "text-xs",
                isRuleValid ? "text-foreground" : "text-muted-foreground",
              )}
            >
              {t(`passwordRules.${rule}`)}
            </span>
          </li>
        );
      })}
    </ul>
  );
}

export default PasswordRulesChecklist;
